interface VehicleTableRow {
  id: string;
  socPct: number;
  state: string;
  station: string;
  nextTrip: string;
}

interface VehicleTableProps {
  rows: VehicleTableRow[];
}

export default function VehicleTable({ rows }: VehicleTableProps) {
  return (
    <div className="w-full overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm">
      <table className="min-w-full divide-y divide-slate-200">
        <thead className="bg-slate-50">
          <tr>
            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
              Vehicle ID
            </th>
            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
              Current SOC
            </th>
            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
              State
            </th>
            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
              Current Station
            </th>
            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
              Next Scheduled Trip
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 bg-white">
          {rows.map((row) => (
            <tr key={row.id}>
              <td className="whitespace-nowrap px-3 py-2 text-sm font-medium text-slate-800">{row.id}</td>
              <td className="whitespace-nowrap px-3 py-2 text-sm text-slate-700">{row.socPct.toFixed(1)}%</td>
              <td className="whitespace-nowrap px-3 py-2 text-sm text-slate-700">{row.state}</td>
              <td className="whitespace-nowrap px-3 py-2 text-sm text-slate-700">{row.station}</td>
              <td className="px-3 py-2 text-sm text-slate-700">{row.nextTrip}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
